import {Button, Container, Stack, Typography} from "@mui/material";
import {useTranslation} from "i18nano";
import useFormattingTranslations from "../hooks/useFormattingTranslations";

interface AuthenticatorAddedComponentProps {
    onClick: () => void;
}

const AuthenticatorAddedComponent: React.FC<AuthenticatorAddedComponentProps> = ({onClick}) => {
    const t = useTranslation();
    const tf = useFormattingTranslations();
    return (
        <Container>
            <Stack
                spacing={2}
                justifyContent={'center'}
                sx={{
                    background: `white`,
                    padding: `32px 26px`,
                    borderRadius: `12px`,
                    boxShadow: `0 4px 6px rgba(0, 0, 0, 0.02),
                    0 10px 24px rgba(0, 0, 0, 0.06),
                    0 0 0 1px rgba(0, 0, 0, 0.02);`}}
            >

                <Typography variant="h4" align={'center'}>
                    {t("Authenticator added")}
                </Typography>
                <Typography variant="body1" gutterBottom align={"center"}>
                    {tf("You have successfully enable two-factor auth", undefined, undefined)}
                </Typography>

                <Button variant="contained" onClick={onClick}>{t("Ok")}</Button>
            </Stack>
        </Container>
    )
}
export default AuthenticatorAddedComponent;